<template>
  <ComputedRow
    v-if="this.attribute.type==='computed'"
    :attribute="attribute"
    :values="values"
    :value="value"
    @input="setValue"
  />
  <component
    v-else
    :is="fieldComponent"
    :attribute="attribute"
    :canEdit="canEdit"
    :isCopied="isCopied"
    :disabled="isCopied"
    :is-multiselect="isMultiselect"
    :loading="loading"
    :value="value"
    @input="setValue"
  />
</template>

<script>
import ComputedRow from './ComputedRow';
import { getFieldComponent } from './fieldComponents';

export default {
  components: {
    ComputedRow
  },
  props: {
    attribute: {
      required: true,
      type: Object
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    isCopied: {
      required: true,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    value: {
      required: true
    },
    values: {
      required: true,
      type: Object
    }
  },
  computed: {
    fieldComponent() {
      return getFieldComponent(this.attribute);
    },
    isMultiselect() {
      return this.attribute.type === 'multiselect';
    }
  },
  methods: {
    setValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>
